import React from "react";
import { Select } from "@cofano/cck";
import { EmailNotificationType } from "__generated__/graphql";
import { intl } from "LocaleWrapper";
import { SelectProps } from "@cofano/cck/Select/Select";

const EmailNotificationTypeSelect = ({ value, onChange }: Omit<SelectProps<EmailNotificationType, false>, "fetchOptions">) =>
	<Select
		fetchOptions={Object.values(EmailNotificationType)}
		getOptionLabel={option => intl.formatMessage({ id: `EMAIL_NOTIFICATION_TYPE_${option}` })}
		value={value}
		clearable={false}
		onChange={onChange}
		disableSearch
	/>;

export default EmailNotificationTypeSelect;
